// extracted by mini-css-extract-plugin
export var searchHeader = "_8z-0";
export var searchHeaderDark = "_8z-1";